'use client';

import React from 'react';
import { Checkbox } from 'src/components';

interface CheckboxListItemProps {
  id: string;
  label: string;
  isSelected: boolean;
  onToggle: (id: string) => void;
}

const CheckboxListItem: React.FC<CheckboxListItemProps> = ({
  id,
  label,
  isSelected,
  onToggle,
}): React.ReactElement => {
  return (
    <div className="px-2" role="option" aria-selected={isSelected}>
      <div
        className={`flex items-center gap-3 px-3 py-2 rounded-full cursor-pointer transition-colors ${
          isSelected ? 'bg-neutral-100' : 'hover:bg-neutral-50'
        }`}
        onClick={() => onToggle(id)}
      >
        <Checkbox
          checked={isSelected}
          onChange={() => onToggle(id)}
          size="sm"
        />
        <span className="text-sm text-primary select-none">{label}</span>
      </div>
    </div>
  );
};

export default CheckboxListItem;
